/* eslint-disable func-names */

$('#marketplace--location-filter--countries > li > label > input').on('change', function () {
  $('#marketplace--location-filter--countries > li > label > input').each(function () {
    const id = `${$(this).attr('id')}--states`;
    $(`#${id}`).hide();
  });
  $('#marketplace--location-filter--states > li > label > input').prop('checked', false);
  $('#marketplace--location-filter--cities > li > label > input').prop('checked', false);

  const id = `${$(this).attr('id')}--states`;

  if (this.checked) {
    $(`#${id}`).show();
  }
});

$('#marketplace--location-filter--states > li > label > input').on('change', function () {
  const id = `${$(this).attr('id')}--cities`;

  if (this.checked) {
    $(`#${id}`).show();
  } else {
    $(`#${id}`).hide();
  }

  $('#marketplace--location-filter--cities > li > label > input').prop('checked', false);
});
